import { atom } from "jotai";
import { MobileSecondaryNavStatus } from "models/enumerations/mobile-secondary-nav-status";

const MobileSecondaryNavStatusAtom = atom<MobileSecondaryNavStatus | null>(
    MobileSecondaryNavStatus.SecondaryNavContent
);

export default MobileSecondaryNavStatusAtom;
